import clsx from "clsx";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import FloatingSupportButton from "./components/FloatingSupportButton/FloatingSupportButton";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import { formatPathname } from "./utils/helpers";
import { RoutingTracking } from "./utils/mixpanel";
import useCacheRequests from "./utils/useCacheRequests";

export default function Layout() {
  const user = useSelector((state) => state.authData.user);
  const loading = useSelector((state) => state.loader.loading);
  const location = useLocation();
  useEffect(() => {
    const pathname = formatPathname(location.pathname);
    RoutingTracking(user?.email, `${pathname}`);
  }, [location]);
  useCacheRequests();
  return (
    <div className="rtl:font-serif">
      <Header />
      <div
        className={clsx({
          "min-h-screen": loading,
        })}
      >
        <Outlet />
      </div>
      <Footer whiteBg={user?.hasOwnProperty("agent")} />
      <FloatingSupportButton />
    </div>
  );
}
